import React, { createContext, useContext, useMemo, useState } from 'react';

interface AppContextType {
  appState: AppStateType;
  setAppState: React.Dispatch<React.SetStateAction<AppStateType>>;
}

interface AppStateType {
  currentPage?: string | null;
  profilePhotoUrl?: string | null;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

export function useAppContext() {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within a AppContextProvider');
  }
  return context;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function AppContextProvider({
  children,
}: {
  readonly children: React.ReactNode;
}) {
  const [appState, setAppState] = useState<AppStateType>({
    currentPage: 'Home',
    profilePhotoUrl: '',
  });

  const memoizedValue = useMemo(
    () => ({ appState, setAppState }),
    [appState, setAppState]
  );

  return (
    <AppContext.Provider value={memoizedValue}>{children}</AppContext.Provider>
  );
}
